import Controler from '../base/Controler';
import megaMenuHover from './megaMenuHover';

class DropdownControler extends Controler {
  constructor() {
    super();
    this.initMegaMenuHover();
  }

  private initMegaMenuHover(): void {
    megaMenuHover();
  }
}

export default DropdownControler;
